import { Box, Typography } from '@mui/material';
import { Swiper } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import { isDesktop } from 'react-device-detect';

import {
  CarouselHeaderStyled,
  SwiperWrapperStyled,
} from './InboxCarouselStyled';
import { MessageSlide } from './components';
import 'swiper/css';
import { FeedMessage } from 'theSource/types';
import { ROUTES } from 'theSource/app/routes';
import { Link } from 'theSource/components';

export interface InboxCarouselProps {
  messages?: Pick<FeedMessage, 'id' | 'title' | 'imageUrl'>[];
}

export const InboxCarousel = ({ messages = [] }: InboxCarouselProps) => {
  const { t } = useTranslation('pages.home');
  let slides = 1;

  if (messages.length === 0) {
    return null;
  }

  if (messages.length !== 1 && !isDesktop) {
    slides = 1.2;
  } else {
    slides = 3;
  }

  return (
    <Box data-testid="inbox-carousel" className="my-3_5">
      <CarouselHeaderStyled>
        <Typography component="div" variant="body2Heading">
          {t('myInbox')}
        </Typography>
        <Link
          testId="view-all-messages-link"
          value={t('viewAllMessages')}
          path={ROUTES.main.inbox.path}
          internal
        />
      </CarouselHeaderStyled>
      <SwiperWrapperStyled>
        <Swiper
          spaceBetween={15}
          slidesPerView={slides}
          centeredSlides
          centeredSlidesBounds
        >
          {messages.map((message) => (
            <MessageSlide
              key={message.id}
              id={message.id}
              text={message.title}
              imgUrl={message.imageUrl}
            />
          ))}
        </Swiper>
      </SwiperWrapperStyled>
    </Box>
  );
};
